<template>
  <div>
    <Loading type="line" :center="false" v-show="loading"/>

    <MovimentList
        :moviments="content.data"
        :totalRecords="content.totalRecords"
        @print="onPrint"
        @attachment="onAttachment"
        @open-items="onOpenItems"
        @delete="onConfirmDelete"
    />

    <Modal
        title="Produto(s)"
        :width="1000"
        :height="600"
        v-if="showModal('movimentItems')"
        :onHideModal="onHideItemsModal"
    >
      <MovimentProductList v-if="selectedMovimentId" :movimentId="selectedMovimentId"/>
    </Modal>

    <Modal
        title="Anexo"
        :width="950"
        :height="750"
        v-if="showModal('movimentAttachment')"
        :onHideModal="onHideAttachmentModal"
    >
      <FileManager
          v-if="showFile"
          :showInModal="false"
          source="moviment"
          :genericId="attachmentMovimentId"
      />
    </Modal>

    <Modal
        title="Excluir Movimentação"
        :width="550"
        v-if="showModal('movimentDelete')"
        :onHideModal="onHideDeleteModal"
    >
      <Alert type="danger">
        <span>
          Ao excluir esta movimentação, <strong>todos os registros vinculados</strong>
          (produtos, patrimônios e histórico) também serão excluídos.
          Esta ação é <strong>irreversível</strong>!
        </span>
      </Alert>
      <Confirmation
          :isModal="false"
          title="Deseja excluir?"
          type="danger"
          :confirmed="deleteMoviment"
      />
    </Modal>
  </div>
</template>

<script>
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Confirmation from "@nixweb/nixloc-ui/src/component/shared/Confirmation.vue";
import FileManager from "@nixweb/nixloc-ui/src/component/shared/file-manager/FileManager";

import MovimentList from "./MovimentList.vue";
import MovimentProductList from "./MovimentProductList.vue";

import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "MovimentMain",
  components: {
    Loading,
    Modal,
    Alert,
    Confirmation,
    FileManager,
    MovimentList,
    MovimentProductList,
  },
  props: {
    rent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      urlGetApi: "/api/v1/stock/moviment/get-all",
      urlDeleteApi: "/api/v1/stock/moviment/delete",
      loading: false,
      content: {
        data: [],
        totalRecords: 0,
      },
      baseParams: {
        search: undefined,
        filter: "contains",
        currentPage: 1,
        totalPerPage: 20,
      },
      selectedMovimentId: "",
      attachmentMovimentId: "",
      showFile: false,
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal"]),
  },
  methods: {
    ...mapActions("generic", ["getApi", "deleteAllApi"]),
    ...mapMutations("generic", ["openModal", "hideModal", "addEvent", "removeLoading"]),

    getAll() {
      if (!this.rent || !this.rent.id) return;
      this.loading = true;
      let params = {
        url: this.urlGetApi,
        obj: {...this.baseParams, rentId: this.rent.id, noPaginated: true},
      };
      this.getApi(params).then((response) => {
        this.content.data = response.content.data;
        this.content.totalRecords = response.content.totalRecords;
        this.loading = false;
      });
    },

    onPrint(params) {
      this.addEvent({name: "printMoviment", data: params.id});
    },

    onAttachment(params) {
      this.attachmentMovimentId = params.id;
      this.showFile = true;
      this.openModal("movimentAttachment");
    },

    onOpenItems(params) {
      this.selectedMovimentId = params.id;
      this.openModal("movimentItems");
    },

    onConfirmDelete(params) {
      this.selectedMovimentId = params.id;
      this.openModal("movimentDelete");
    },

    deleteMoviment() {
      let params = {
        url: this.urlDeleteApi,
        selected: [this.selectedMovimentId],
      };
      this.deleteAllApi(params).then((response) => {
        if (response.success) {
          this.hideModal("movimentDelete");
          this.getAll();
          this.addEvent({name: "movimentDeleted", data: {movimentId: this.selectedMovimentId}});
        }
        this.removeLoading(["confirm"]);
      });
    },

    onHideItemsModal() {
      this.selectedMovimentId = "";
    },

    onHideAttachmentModal() {
      this.showFile = false;
      this.attachmentMovimentId = "";
    },

    onHideDeleteModal() {
      this.selectedMovimentId = "";
    },
  },
  watch: {
    "rent.id": {
      handler(newId) {
        if (newId) this.getAll();
      },
      immediate: true,
    },
  },
};
</script>

